import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "success"
}
const _hoisted_2 = {
  key: 1,
  class: "flex-container-col gap20"
}
const _hoisted_3 = { class: "flex-container-row" }
const _hoisted_4 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_error = _resolveComponent("error")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_login_content = _resolveComponent("login-content")!

  return (_openBlock(), _createBlock(_component_login_content, {
    title: _ctx.title,
    "in-progress": _ctx.state.sendingInProgress,
    "error-message": _ctx.state.errorMessage,
    links: _ctx.links
  }, {
    default: _withCtx(() => [
      (_ctx.state.emailWasSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.localize('PasswordRequestSent')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.localize('PasswordResetInstructions')), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_k_input, {
                id: "txtEmail",
                placeholder: _ctx.localize('EnterUsername'),
                label: _ctx.localize('Username'),
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event))
              }, null, 8, ["placeholder", "label", "modelValue"]),
              _withDirectives(_createVNode(_component_error, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.state.emailIsMissing]
              ])
            ]),
            _createVNode(_component_k_button, { onClick: _ctx.sendEmail }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localize('Send')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
    ]),
    _: 1
  }, 8, ["title", "in-progress", "error-message", "links"]))
}